// extracted by mini-css-extract-plugin
export default {"overlay":"EVU04FlMM76VJWGBKAYw"};